import React, { useRef } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { BonusSection } from '../components/BonusSection';
import { PurchaseSection } from '../components/PurchaseSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { StickyBuyBar } from '../components/StickyBuyBar';
export function LandingPage() {
  const purchaseRef = useRef<HTMLDivElement>(null);
  const scrollToPurchase = () => {
    purchaseRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#fafaf9] font-sans text-[#1a1a1a]" data-id="element-331">
      <UrgencyBar data-id="element-332" />

      <main data-id="element-333">
        <HeroSection onScrollToPurchase={scrollToPurchase} data-id="element-334" />
        <PainSection data-id="element-335" />
        <SolutionSection data-id="element-336" />
        <BenefitsSection data-id="element-337" />
        <BonusSection onScrollToPurchase={scrollToPurchase} data-id="element-338" />

        <div ref={purchaseRef} data-id="element-339">
          <PurchaseSection data-id="element-340" />
        </div>

        <TestimonialsSection data-id="element-341" />
      </main>

      <footer className="bg-[#1a1a1a] text-white py-8 text-center text-sm pb-24 md:pb-8" data-id="element-342">
        <div className="max-w-6xl mx-auto px-4" data-id="element-343">
          <p className="opacity-60" data-id="element-344">
            © 2026 Guía para Hacer Esquejes. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <PurchaseNotification data-id="element-345" />
      <StickyBuyBar onScrollToPurchase={scrollToPurchase} data-id="element-346" />
    </div>;
}